<template>
  <page-view title>
    <div slot="headerContent">
      <!-- mgMovieFlag：是芒果电影票订单专享的，芒果电影票订单不需要显示筛选机器人搜索框 -->
      <search-robot @changeRobotId="onChangeRobotId" :mgMovieFlag="false"></search-robot>
    </div>
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="DingDanGuanLi"></demo-video-alert>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">商户ID</a-select-option>
                  <a-select-option value="2">订单编号</a-select-option>
                  <a-select-option value="3">下单用户ID</a-select-option>
                  <a-select-option value="4">支付状态</a-select-option>
                  <a-select-option value="5">订单状态</a-select-option>
                  <a-select-option value="6">购买张数</a-select-option>
                  <a-select-option value="7">电影名称</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="搜索关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>

            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator" v-if="false">
        <a-button type="primary" :disabled="OrderDownloadStatus.conduct ? true : false"
          @click="handleDownLoad">同步订单</a-button>
        <div style="width: 200px; margin-top: -3px">
          <a-progress v-if="OrderDownloadStatus.conduct" :percent="OrderDownloadStatus.progress" size="small"
            :format="percent => parseInt(percent) + '%'" />
        </div>
      </div>
      <a-dropdown placement="bottomLeft" :trigger="['click']" :disabled="selectedRowKeys.length === 0">
        <a-button style="margin-bottom:10px" type="primary">批量操作</a-button>
        <a-menu slot="overlay">
          <a-menu-item @click="handleMoreJiesuan" :disabled="!canClickMore">
            <a-tooltip>
              <template slot="title" v-if="!canClickMore">
                所选机器人ID不一致
              </template>
              批量结算
            </a-tooltip>
          </a-menu-item>
          <a-menu-item @click="handleMoreJiedong" :disabled="!canClickMore">批量解冻</a-menu-item>
          <a-menu-item @click="handleMoreJiebang" :disabled="!canClickMore">批量解绑</a-menu-item>
          <a-menu-item @click="$refs.replaceUidModal.showMore(selectedGoods, sourceby)"
            :disabled="!canClickMore">批量换绑</a-menu-item>
          <a-menu-item @click="handleMoreTuikuan" :disabled="!canClickMore">批量退款</a-menu-item>
        </a-menu>
      </a-dropdown>
      <s-table ref="table" rowKey="id" :scroll="{ x: 300 }" :columns="columns" :data="loadData"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="order_no" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span v-line-clamp="1">{{ text }}</span>
          </a-tooltip>
        </span>

        <span slot="item_img" slot-scope="text,record">
          <a-popover title="电影图片">
            <template slot="content">
              <img :src="text" style="max-width: 200px" />
            </template>
            <a-avatar shape="square" icon="picture" :src="text" />
          </a-popover>
          <br />
          <a-tag color='pink' style="margin-top: 5px;">{{ record.film_name }}</a-tag>
          <a-tag color="green">电影ID：{{ record.film_id }}</a-tag>
        </span>
        <!-- <span slot="order_title" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <a v-line-clamp="1">{{ text }}</a>
          </a-tooltip>
        </span> -->
        <!-- 商品信息 -->
        <span slot="goods_info" slot-scope="text, record">
          <span>
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ record.goodsName }}</span>
              </template>
              <a v-line-clamp="1">{{ record.goodsName }}</a>
            </a-tooltip>
          </span>

          <a-tag color="orange">下单用户ID：{{ record.user_id }}</a-tag>
          <a-tag color="purple">所得利润：{{ record.share_user_rebate || 0 | currency('￥') }}</a-tag>

          <a-tag color="blue">付款金额：{{ record.final_price || 0 | currency('￥') }}</a-tag>
          <a-tag color="pink">猫眼原价：{{ record.maoyan_price || 0 | currency('￥') }}</a-tag>
          <a-tag color="cyan">快速出票价格：{{ record.qmm_price || 0 | currency('￥') }}</a-tag>
        </span>
        <!-- 状态 -->
        <span slot="order_fanli_Info_slotd" slot-scope="text, record">
          <a-tag v-if="record.pay_state == '-1'" color="blue">支付状态：退款</a-tag>
          <a-tag v-else-if="record.pay_state == '0'" color="blue">支付状态：待支付</a-tag>
          <a-tag v-else-if="record.pay_state == '1'" color="blue">支付状态：已支付</a-tag>
          <a-tag v-else color="red">未知状态</a-tag>


          <a-tag color="orange" v-if="record.yk_order_status == '-2'">订单状态：出票失败</a-tag>
          <a-tag color="orange" v-else-if="record.yk_order_status == '-1'">订单状态：支付超时</a-tag>
          <a-tag color="orange" v-else-if="record.yk_order_status == '0'">订单状态：待支付</a-tag>
          <a-tag color="orange" v-else-if="record.yk_order_status == '1'">订单状态：待出票</a-tag>
          <a-tag color="orange" v-else-if="record.yk_order_status == '2'">订单状态：已出票</a-tag>
          <a-tag color="orange" v-else-if="record.yk_order_status == '3'">订单状态：完成</a-tag>
          <a-tag v-else color="red">未知状态</a-tag>

          <a-tag style="margin-top: 2px;" v-if="record.pay_client == '1'" color="green">支付方式：微信支付</a-tag>
          <a-tag style="margin-top: 2px;" v-else-if="record.pay_client == '2'" color="green">支付方式：支付宝支付</a-tag>
          <a-tag style="margin-top: 2px;" v-else-if="record.pay_client == '3'" color="green">支付方式：共生鸟</a-tag>
          <a-tag style="margin-top: 2px;" v-else-if="record.pay_client == '4'" color="green">支付方式：汇聚支付</a-tag>
        </span>
        <!-- 支付方式 -->
        <span slot="pay" slot-scope="text, record">
          <a-tag v-if="record.pay_client == '1'" color="blue">微信支付</a-tag>
          <a-tag v-else-if="record.pay_client == '2'" color="blue">支付宝支付</a-tag>
          <a-tag v-else-if="record.pay_client == '3'" color="blue">共生鸟</a-tag>
          <a-tag v-else-if="record.pay_client == '4'" color="blue">汇聚支付</a-tag>


        </span>
        <!-- 订单信息 -->
        <span slot="order_info" slot-scope="text, record">
          <span>
            <a-tag color="pink">出票时间： {{ record.ticket_time ? getDate(record.ticket_time) : '无出票时间' }}</a-tag>
          </span>
          <span>
            <a-tag color="green">购买张数： {{ record.ticket_num }}</a-tag>
          </span>

        </span>
        <!-- <span slot="user_info" slot-scope="text, record">
          <a-tooltip placement="left" v-if="text && text != null">
            <template slot="title">
              <span>{{ text.nickname }}（uid:{{ text.uid }}）</span>
            </template>
            <span v-line-clamp="1">{{ text.nickname }}</span>
          </a-tooltip>

          <a-tooltip placement="left" v-else>
            <template slot="title">
              <span>{{
                record.binding_miss_remark
                  ? record.binding_miss_remark
                  : record.op_status === 1
                  ? '等待机器人处理'
                  : '请手动绑定订单'
              }}</span>
            </template>
            <a>未绑定 <a-icon type="question-circle" /></a>
          </a-tooltip>
        </span> -->
        <!-- <span slot="rmb2_slot" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span> -->
        <!-- <span slot="rmb_slot" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span> -->
        <!-- <span slot="order_status_slot" slot-scope="text">
          <a-badge v-if="text == '1'" status="processing" text="等待付款" />
          <a-badge v-else-if="text == '2'" status="processing" text="已付款" />
          <a-badge v-else-if="text == '3'" status="processing" text="已签收" />
          <a-badge v-else-if="text == '4'" status="warning" text="待结算" />
          <a-badge v-else-if="text == '5'" status="success" text="已结算" />
          <a-badge v-else-if="text == '6'" status="error" text="已失效" />
          <a-badge v-else status="error" text="未知状态" />
        </span> -->
        <!-- <span slot="total_reward" slot-scope="text">
          <span>{{ text || 0 | currency('￥') }}</span>
        </span> -->
        <!-- <span slot="order_fanli_status_slot" slot-scope="text">
          <span>{{ text | getOrderFanliStatus }}</span>
        </span>
        <span slot="accountdt" slot-scope="text">
          <span>{{ text ? getDate(text) : '暂未结算' }}</span>
        </span>
        <span slot="createdt" slot-scope="text">
          <span>{{ text ? getDate(text) : '无创建时间' }}</span>
        </span>
        <span slot="mmpid" slot-scope="text, record">
          <span>{{ record.p_id }}</span>
        </span>
        <span slot="order_dongjie_status_slot" slot-scope="text">
          <span>
            <a-tag color="red" v-if="text == '1'">已冻结</a-tag>
            <a-tag color="blue" v-else>未冻结</a-tag>
          </span>
        </span> -->
        <span slot="action" slot-scope="text, record">
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item @click="handleJiesuan(record)" :disabled="
                record.orderSubStatus == 1 ||
                record.orderSubStatus == 2 ||
                record.orderSubStatus == 6 ||
                record.flstatus != 0
              ">结算</a-menu-item>
              <a-menu-item @click="handleJiedong(record)" :disabled="record.luckdrawTAG != 1">解冻</a-menu-item>
              <a-menu-item @click="handleJiebang(record)" :disabled="record.user_info ? false : true">解绑</a-menu-item>
              <a-menu-item @click="$refs.replaceUidModal.show(record.sub_id, record.uni_id, sourceby)">换绑</a-menu-item>
              <a-menu-item @click="handleTuikuan(record)"
                :disabled="record.orderSubStatus != '3' && record.orderSubStatus != '4' && record.orderSubStatus != '5'">退款</a-menu-item>
            </a-menu>
            <a>
              更多
              <a-icon type="down" />
            </a>
          </a-dropdown>
        </span>
      </s-table>
    </a-card>
    <!-- 下载订单 -->
    <down-modal ref="downModal"></down-modal>
    <!-- 换绑 -->
    <replace-uid-modal ref="replaceUidModal" @ok="$refs.table.refresh(true)"></replace-uid-modal>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import ReplaceUidModal from '@/views/order-new/modules/ReplaceUidModal'
import OrderApi from '@/api/order-new'
import { PageView } from '@/layouts'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { mixinOrder } from '@/utils/mixin'
import { ORDER_SYNC_PDD } from '@/store/mutation-types'
import DownModal from './modules/DownModal'
import { DATA_ORDER_STATUS, DATA_ORDER_FANLI_STATUS } from './data'
import { ExceptionPage } from '@/components'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
// const statusMap = {
//   1: {
//     status: 'processing',
//     text: '正常',
//   },
//   3: {
//     status: 'error',
//     text: '已过期',
//   },
// }

export default {
  name: 'OrderMgmovie',
  components: {
    PageView,
    STable,
    SearchRobot,
    DownModal,
    ExceptionPage,
    ReplaceUidModal,
    DemoVideoAlert,
  },
  data() {
    return {
      sourceby: 4, // 来源
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          width: 50,
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '商户ID',
          width: 100,
          dataIndex: 'fans_id',
        },
        {
          title: '订单号',
          width: 200,
          dataIndex: 'order_number',
          scopedSlots: { customRender: 'order_no' },
        },
        {
          title: '电影信息',
          dataIndex: 'film_img',
          width: 80,
          scopedSlots: { customRender: 'item_img' },
        },
        // {
        //   title: '商品标题',
        //   width: 200,
        //   dataIndex: 'goodsName',
        //   scopedSlots: { customRender: 'order_title' },
        // },
        // {
        //   title: '商品ID',
        //   width: 120,
        //   dataIndex: 'goodsId',
        // },
        // {
        //   title: '付款金额',
        //   width: 100,
        //   dataIndex: 'totalCost',
        //   scopedSlots: { customRender: 'rmb2_slot' },
        // },
        {
          title: '利润信息',
          width: 200,
          scopedSlots: { customRender: 'goods_info' },
        },
        {
          title: '支付 订单信息',
          width: 260,
          scopedSlots: { customRender: 'order_fanli_Info_slotd' },
        },
        // {
        //   title: '总佣金',
        //   width: 100,
        //   dataIndex: 'commission',
        //   scopedSlots: { customRender: 'total_reward' },
        // },
        // {
        //   title: '支付方式',
        //   width: 150,
        //   dataIndex: 'pay_client',
        //   scopedSlots: { customRender: 'pay' },
        // },
        // {
        //   title: '用户奖励',
        //   width: 100,
        //   dataIndex: 'fl_user',
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        // {
        //   title: '上级奖励',
        //   width: 100,
        //   dataIndex: 'fl_agent',
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        // {
        //   title: '上上级奖励',
        //   width: 150,
        //   dataIndex: 'fl_second',
        //   sorter: true,
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        // {
        //   title: '群主奖励',
        //   width: 100,
        //   dataIndex: 'fl_group',
        //   scopedSlots: { customRender: 'rmb_slot' },
        // },
        {
          title: '订单信息',
          width: 220,
          scopedSlots: { customRender: 'order_info' },
          sorter: true,
        },
        // {
        //   title: '订单状态',
        //   width: 120,
        //   dataIndex: 'orderSubStatus',
        //   scopedSlots: { customRender: 'order_status_slot' },
        // },
        // {
        //   title: '返利状态',
        //   width: 100,
        //   dataIndex: 'flstatus',
        //   scopedSlots: { customRender: 'order_fanli_status_slot' },
        // },
        // {
        //   title: '冻结状态',
        //   width: 100,
        //   dataIndex: 'luckdrawTAG',
        //   scopedSlots: { customRender: 'order_dongjie_status_slot' },
        // },
        // {
        //   title: '结算时间',
        //   width: 200,
        //   dataIndex: 'settledTime',
        //   sorter: true,
        //   scopedSlots: { customRender: 'accountdt' },
        // },
        // {
        //   title: '推广位',
        //   width: 170,
        //   scopedSlots: { customRender: 'mmpid' },
        // },
        // {
        //   title: '创建时间',
        //   dataIndex: 'orderTime',
        //   scopedSlots: { customRender: 'createdt' },
        // },
        // {
        //   title: '操作',
        //   width: '100px',
        //   fixed: 'right',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return OrderApi.getMgMovieOrderList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
            // main_id:1515
          })
        ).then(res => {
          this.selectedRowKeys = []
          return res
        })
      },
    }
  },
  mixins: [mixinOrder],
  filters: {
    getOrderStatus(status) {
      const dataObj = DATA_ORDER_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },

    getOrderFanliStatus(status) {
      const dataObj = DATA_ORDER_FANLI_STATUS
      if (dataObj[status]) {
        return dataObj[status]['text']
      } else {
        return '未知'
      }
    },
  },
  computed: {
    OrderDownloadStatus() {
      const pinduoduoStatus = this.$store.state.order.pinduoduoStatus
      return pinduoduoStatus[this.currentRobotId] ? pinduoduoStatus[this.currentRobotId] : {}
    },
  },
  created() { },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'demoSetVideo']),
    getDate(time) {
      if (!time) return '无'
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    handleDownLoad() {
      // const time = this.$ls.get(ORDER_SYNC_PDD)
      // if (!(time && +moment() - time < 60 * 60 * 1000)) {
      this.$refs.downModal.show(this.currentRobotId)
      // } else {
      //   this.$message.error('60分钟内请不要重复操作！')
      // }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 结算
    handleJiesuan({ uni_id, sub_id }) {
      const orderid = uni_id
      const robotid = sub_id
      // console.log(orderid, robotid)
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: robotid,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '1',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    // 解冻
    handleJiedong({ uni_id, sub_id }) {
      const orderid = uni_id
      const robotid = sub_id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: robotid,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '2',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    // 退款
    handleTuikuan({ uni_id, sub_id }) {
      const orderid = uni_id
      const robotid = sub_id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: robotid,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '3',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    // 解绑
    handleJiebang({ uni_id, sub_id }) {
      const orderid = uni_id + ''
      const robotid = sub_id
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: robotid,
        type: 'operationorder',
        data: {
          orderid: orderid,
          type: '5',
          sourceby: this.sourceby,
        },
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
  },
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/deep/ .page-header {
  .extra {
    display: none;
  }

  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
